const CARD_SELECTOR = 'product-card, .predictive-search-product-card';
const OVERLAY_SELECTOR = '[data-product-card-size-hover]';
const TARGET_TEXT_SELECTOR = '.product-card__content > [class*="text-block--"][class*="__text_"]';

function getTargetTextBlock(card) {
  if (card.matches('.predictive-search-product-card')) {
    return card.querySelector('.resource-card__vendor');
  }

  const content = card.querySelector('.product-card__content');
  if (!content) return null;

  const standardVendor = content.querySelector(':scope > .product-card__standard-vendor');
  if (standardVendor) return standardVendor;

  const titleText = card.querySelector('[ref="productTitleLink"] .text-block');
  const directTextBlocks = [...content.querySelectorAll(TARGET_TEXT_SELECTOR)];
  const preferredTarget = directTextBlocks.find((textBlock) => textBlock !== titleText);

  if (preferredTarget) return preferredTarget;

  return [...content.querySelectorAll('.text-block')].find((textBlock) => textBlock !== titleText) || null;
}

function setupCardSizeHover(card) {
  const overlay = card.querySelector(OVERLAY_SELECTOR);
  if (!overlay || overlay.dataset.jlfMounted === 'true') return;

  const target = getTargetTextBlock(card);
  if (!target) return;

  target.classList.add('product-card-size-hover-target');
  target.append(overlay);
  overlay.dataset.jlfMounted = 'true';
}

function setupSizeHovers(root = document) {
  if (root.matches?.(CARD_SELECTOR)) {
    setupCardSizeHover(root);
  }

  root.querySelectorAll(CARD_SELECTOR).forEach(setupCardSizeHover);
}

setupSizeHovers();

document.addEventListener('shopify:section:load', (event) => {
  setupSizeHovers(event.target);
});

document.addEventListener('shopify:section:reorder', (event) => {
  setupSizeHovers(event.target);
});

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof Element) {
        setupSizeHovers(node);
      }
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
